import axios, { type AxiosRequestConfig } from 'axios'
import { client } from 'ply-api'
import PolicyResolver from './policy-resolver'

const UPLOAD_URL = 'https://s3.amazonaws.com/static.adk2.com'

const POLICY_RESOLVERS = {}

type S3Policy = {
	prefix: string
	accessKey: string
	policy: string
	signature: string
}

export default class Uploader {
	_policy: PolicyResolver<S3Policy>
	_uploadUrl: string

	constructor({ policyUrl, uploadUrl = UPLOAD_URL }) {
		this._policy = this.getPolicyResolver({ url: policyUrl })
		this._uploadUrl = uploadUrl
	}

	getPolicyResolver = ({ url }): PolicyResolver<S3Policy> => {
		if (POLICY_RESOLVERS[url]) {
			return POLICY_RESOLVERS[url]
		}

		const fetchFn = () => client(url) as Promise<S3Policy>

		POLICY_RESOLVERS[url] = new PolicyResolver({ fetchFn })

		return POLICY_RESOLVERS[url]
	}

	getPolicy() {
		try {
			return this._policy.resolve()
		} catch (_) {
			return null
		}
	}

	async upload({
		file,
		onUploadProgress = null,
	}: {
		file: File
		onUploadProgress?: AxiosRequestConfig['onUploadProgress'] | null
	}) {
		// if (process.env.NODE_ENV !== 'production') {
		//   console.warn('mocking upload')
		//   await new Promise((resolve) => setTimeout(resolve, 1000))

		//   return `${this._uploadUrl}/${file.name}`
		// }

		return await this._uploadFile({ file, onUploadProgress })
	}

	async _uploadFile({ file, onUploadProgress }) {
		try {
			const policy = await this.getPolicy()

			if (!policy) {
				throw new Error("uploader can't get a policy")
			}

			const formData = new FormData()
			const key = policy.getKey()

			formData.append('key', key)
			formData.append('acl', 'public-read')
			formData.append('content-type', 'application/octet-stream')
			formData.append('AWSAccessKeyId', policy.accessKey)
			formData.append('policy', policy.policy)
			formData.append('signature', policy.signature)
			formData.append('file', file)

			await axios.post(this._uploadUrl, formData, {
				onUploadProgress,
			})

			return `${this._uploadUrl}/${key}`
		} catch (e: any) {
			throw new Error(`Failed to upload '${file.name}' (${e.message})`)
		}
	}
}
